/**
 * Block 12 calculator — перевод миллиметров в метры.
 *
 * Все anketa-параметры (L, L2, H, D) хранятся в миллиметрах (per
 * `BaseDimensionsSchema` в `contracts/calculator.ts`), но xlsx-формулы
 * оперируют метрами. Это маленький helper для конверсии.
 *
 * Reference: `docs/methodology/calculator-formulas.md` §5.
 *
 * @example
 *   mmToM(1000) // 1
 *   mmToM(2500) // 2.5
 *   mmToM(2900) // 2.9
 *
 * @throws Error если `mm` не конечное число — fail-fast вместо тихого NaN.
 */
export function mmToM(mm: number): number {
  if (!Number.isFinite(mm)) {
    throw new Error(`mmToM: expected finite number, got ${mm}`);
  }
  return mm / 1000;
}
